import { BaseEntity } from '../base/base.entity';
import { AppService } from '../main/app.service';
import { BaseService } from '../base/base.service';


export class ITeam extends BaseEntity {
    name: string;
    locationId: string;
    teamContacts: any;
    salaryScaleGroupId?: string; // Optioneel: als team een eigen CAO heeft
}

export class TeamService extends BaseService<ITeam> {
 
    constructor(protected Restangular: Restangular.IService, protected AppService: AppService) {
        "ngInject";
        super(Restangular, AppService, 'team');
    }
}


// WEBPACK FOOTER //
// ./src/app/services/team.service.ts